import { TOGGLE_TRAFFIC } from "./showTrafficReducer"

export const toggleTrafficOnMap = () => ({
    type: TOGGLE_TRAFFIC,
})